import {
  Component,
  ElementRef,
  HostBinding,
  Input,
  ViewChild
} from '@angular/core';
import { MenuIconTypes } from '../dynamic-menu-icon/dynamic-menu-icon.component';

@Component({
  selector: 'bepatient-menu-main-button',
  templateUrl: './menu-main-button.component.html',
  styleUrls: ['./menu-main-button.component.scss'],
  standalone: false
})
export class MenuMainButtonComponent {
  @Input() icon: MenuIconTypes;
  @Input() label: string;
  @Input() color: string;
  @Input() iconColor: string;
  @Input() notifications: number;

  @HostBinding('class.reversed') @Input() reversed: boolean;
  @ViewChild('labelRef', { read: ElementRef, static: true })
  labelElementRef: ElementRef;

  @Input() set selected(v: boolean) {
    this.labelElementRef.nativeElement.style.setProperty(
      'color',
      v ? this.color : 'var(--ion-text-color)'
    );
  }
}
